var scriptLoaderInterface = {

        load: function(urls, callback){
        $script(urls, callback);
    }

    };


